import { PasscodeOnboarding } from "@/components/Elemnt/Onboarding/PasscodeOnboarding";
import { useParams } from "react-router";

const PasscodeOnboardingPage = () => {
  const { appToken = "" } = useParams();
  return <PasscodeOnboarding appToken={appToken} />;
};

export default PasscodeOnboardingPage;
